async function generateRecaptchaToken(action)
{
    return new Promise((resolve) =>
    {
        grecaptcha.ready(() =>
        {
            void (async () =>
            {
                var token = await grecaptcha.execute(window.recaptchaConfig.siteKey, { action: action });

                resolve(token);
            })();
        });
    });
}

async function getRecaptchaToken(data)
{
    var action = data.captchaAction || window.recaptchaConfig.action;

    try
    {
        var result = await generateRecaptchaToken(action);

        return result;
    }
    catch (error)
    {
        console.log(`reCAPTCHA error: ${error}`);

        return null;
    }
}

window.captcha =
{
    handleErrorAsync: async function (response)
    {
        if (response.status !== 400)
            return;

        var contentType = response.headers.get('Content-Type');

        if (!contentType || contentType.indexOf('application/json') < 0)
            return;

        var errorData = await response.json();

        var isCaptchaError = errorData && (errorData.Type && errorData.Type == "CAPTCHA" || errorData.type && errorData.type == "CAPTCHA");

        if (!isCaptchaError)
            return;

        // show warning
        setTimeout(async() =>
        {
            Swal.fire(
            {
                title: await localization.get("captcha.failure.title"),
                text: errorData.Message || errorData.message,
                icon: 'warning',
                confirmButtonText: await localization.get("captcha.failure.button")
            });
        }, 500);
    },
    isEnabled: function ()
    {
        if (window.recaptchaConfig)
            return window.recaptchaConfig.isEnabled;

        return false;
    },
    getTokenAsync: async function (data)
    {
        if (window.recaptchaConfig)
            return await getRecaptchaToken(data);

        return null;
    },
    shouldValidateForm: function (form)
    {
        return form && form.hasAttribute("data-captcha");
    }
};